import React from 'react'

import { Loader, PriceString } from '@fourthwall/components'
import type { Money } from '@fourthwall/services/dist/models/common'
import { SelectPaymentMethod } from '@modules/Dashboard/modules/PaymentMethods'
import type { PaymentMethodItem } from '@modules/Dashboard/modules/PaymentMethods/PaymentMethods.types'

import { TermsFooter } from '../TermsFooter/TermsFooter'
import * as S from './PaymentStage.styled'

export type PaymentStageProps = {
  total: Money
  isSubmitting: boolean
  onSuccess: () => void
  onAddPaymentMethodClose?: () => void
  onSubmitCallback?: (paymentMethod?: PaymentMethodItem) => void
}

export const PaymentStage = ({
  total,
  isSubmitting,
  onSuccess,
  onAddPaymentMethodClose,
  onSubmitCallback,
}: PaymentStageProps) => {
  return (
    <SelectPaymentMethod
      submitLabel="Pay now"
      withChargeLimit={false}
      onSuccess={onSuccess}
      onAddPaymentMethodClose={onAddPaymentMethodClose}
      onSubmitCallback={onSubmitCallback}
    >
      {({ isLoading, renderSubmitButton, renderContent }) => (
        <>
          {isLoading && (
            <S.LoaderWrapper>
              <Loader size="large" />
            </S.LoaderWrapper>
          )}

          <S.Content>
            {!isLoading && <S.SecondaryText>Payment method</S.SecondaryText>}
            <S.PaymentMethodsContainer>
              <S.PaymentMethodsWrapper>{renderContent()}</S.PaymentMethodsWrapper>
            </S.PaymentMethodsContainer>
          </S.Content>

          <S.TotalSummaryContainer>
            <span>Total to pay</span>
            <span>
              <PriceString {...total} />
            </span>
          </S.TotalSummaryContainer>
          {renderSubmitButton({ isLoading: isSubmitting })}
          <TermsFooter />
        </>
      )}
    </SelectPaymentMethod>
  )
}
